module.exports = __webpack_public_path__ + "static/portfolio-f2c-furniture-2a7b6030957e17a38e9423ae8e8b21d6.png";